<template>
  <v-card>
    <spinner-overlay
      :show-overlay="showOverlay"
      :show-spinner="showSpinner"
    />
    <v-card-title class="justify-center text-uppercase">
      Current plan
    </v-card-title>
    <v-card-text class="text-center">
      <h3 class="mb-6 text-uppercase">
        {{ currentPlanName }}
      </h3>
      <p>{{ formattedPrice }} per {{ interval }}</p>
      <p>Your plan renews on {{ renewalDate }}</p>
    </v-card-text>
    <v-card-actions class="d-flex justify-space-around">
      <v-btn
        color="primary"
        @click="manageSubscription"
      >
        Manage your plan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatAsCurrency, formatAsDisplayDate } from '@/utils/localeFormat'
import SpinnerOverlay from '@/components/SpinnerOverlay.vue'

export default {
  name: 'CurrentSubscriptionDetails',
  components: { SpinnerOverlay },
  data() {
    return {
      showSpinner: true,
      showOverlay: true
    }
  },
  computed: {
    returnUrl() {
      return window.location.href
    },
    currentPlanName() {
      return this.subscription.name
    },
    subscription() {
      return this.accountStatus.subscription
    },
    interval() {
      return this.subscription.interval
    },
    formattedPrice() {
      const { amount: amountInCents, currency } = this.subscription
      return formatAsCurrency({ amountInCents, currency })
    },
    renewalDate() {
      return formatAsDisplayDate(this.subscription.currentPeriodEnd.toDate())
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_accountStatus']).then(async () => {
      this.showSpinner = false
      this.showOverlay = false
    })
    this.mapStates(['accountStatus'])
  },
  methods: {
    async manageSubscription() {
      this.showSpinner = true
      this.showOverlay = true
      const {
        data: { url }
      } = await this.$api.createPortalLink({ returnUrl: this.returnUrl })
      this.showSpinner = false
      window.location.assign(url)
    }
  }
}
</script>
